import {
  incPeriodIndex,
  decPeriodIndex,
  resetPeriodIndex,
  setFilter,
    setControls,
} from '../../../State/controls'
import { resetData } from '../../../State/data'
import fetch from '../../../Services/fetch'

export default (key, value) => (dispatch) => {

  switch (key) {

    case 'inc-period-index':
      dispatch(incPeriodIndex())
dispatch(resetData())
      dispatch(fetch())
      break

    case 'dec-period-index':
      dispatch(decPeriodIndex())
dispatch(resetData())
      dispatch(fetch())
      break

    case 'reset-period-index':
      dispatch(resetPeriodIndex())
dispatch(resetData())
      dispatch(fetch())
      break

    case 'yAxis':
      dispatch(setFilter({ key, value }))
      if (value !== 'map') {
        dispatch(resetData())
        dispatch(fetch())
      }
      break

    case 'summary':
      dispatch(setFilter({ key, value }))
      dispatch(resetData())
      dispatch(fetch())
      break

    case 'projectSearch':
    case 'subcontractorSearch':
    case 'shrink':
      dispatch(setFilter({ key, value }))
      break

    case 'ganttSettingDuration':
        dispatch(setFilter({ key, value }))
dispatch(resetData())

        dispatch(fetch())

    break

    default:
      dispatch(setFilter({ key, value }))
dispatch(resetData())
      dispatch(fetch())
      break

  }

}
